import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './styles/fonts.css';
import UniversityPage from './pages/UniversityPage';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import MenuPage from './pages/MenuPage';
import DishesPage from './pages/DishesPage';
import DishPage from './pages/DishPage';
import StreetFoodPage from './pages/StreetFoodPage';
import VegetarianPage from './pages/VegetarianPage';
import NotFound from './pages/NotFound';

// Import Swiper styles for the locations carousel
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/dishes" element={<DishesPage />} />
          <Route path="/dishes/:slug" element={<DishPage />} />
          <Route path="/thai-street-food-seattle" element={<StreetFoodPage />} />
          <Route path="/vegetarian-thai-seattle" element={<VegetarianPage />} />
          <Route path="/near-uw" element={<UniversityPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
